import { render, staticRenderFns } from "./DirectTeachingActivityView.vue?vue&type=template&id=45d965b4&scoped=true"
import script from "./DirectTeachingActivityView.vue?vue&type=script&lang=js"
export * from "./DirectTeachingActivityView.vue?vue&type=script&lang=js"
import style0 from "./DirectTeachingActivityView.vue?vue&type=style&index=0&id=45d965b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45d965b4",
  null
  
)

export default component.exports